import { useEffect, useRef, useState } from 'react';
import { realtime, type ConnStatus, type RealtimeEvent } from './client';

export function useConnectionStatus(): ConnStatus {
  const [s, set] = useState<ConnStatus>(realtime.status);
  useEffect(() => {
    const off = realtime.onStatus(set);
    return () => {
      off();
    };
  }, []);
  return s;
}

/** Subscribe to channels; the handler always sees the latest closure. */
export function useChannels(channels: string[], handler: (e: RealtimeEvent) => void) {
  const ref = useRef(handler);
  ref.current = handler;
  const key = channels.join('|');
  useEffect(() => {
    if (!channels.length) return;
    return realtime.subscribe(channels, (e) => ref.current(e));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
}

/** Trailing-edge debounce (spec: batch high-frequency updates every 500 ms). */
export function useDebounced(fn: () => void, ms: number) {
  const ref = useRef(fn);
  ref.current = fn;
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => () => {
    if (timer.current) clearTimeout(timer.current);
  }, []);
  return () => {
    if (timer.current) return;
    timer.current = setTimeout(() => {
      timer.current = null;
      ref.current();
    }, ms);
  };
}
